(function() {
	'use strict';

	angular.module('app.core')
		.service('cookieService', cookieService);

	cookieService.$inject = [];
	function cookieService() {
		return {
			checkForUICookie: checkForUICookie
		};

		function checkForUICookie(search, cookieObject, cookieName) {
			if (search.hasOwnProperty(cookieName)) {
				cookieObject[cookieName] = search[cookieName] === 'true';
				// set cookie
				var m = moment().add(365, 'days');
				document.cookie = cookieName + '=' + cookieObject[cookieName] + ';expires=' + m._d.toUTCString() + ';path=/';
			} else {
				cookieObject[cookieName] = false;
				var decodedCookie = decodeURIComponent(document.cookie);
				var ca = decodedCookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var keyvalue = ca[i].split('=');
					var key = keyvalue[0];
					var value = keyvalue[1];
					if (key || key == 0) { // == on purpose
						key = key.toString().trim();
					}
					if (value || value == 0) { // == on purpose
						value = value.toString().trim();
					}
					if (key === cookieName) {
						cookieObject[cookieName] = value === 'true';
						break;
					}
				}
			}
		}
	}

})();
